/** Account type key for customer/supplier accounts in structure and search APIs. */
export const CUSTOMER_ACCOUNT_TYPE = "לקוח-ספק" as const;

/** Base route path for the customers browse page. */
export const CUSTOMERS_PATH = "/customers";

/** Default breadcrumb labels for the customers section. */
export const CUSTOMERS_BREADCRUMB = {
  ledger: "כרטסות",
  list: "לקוחות/ספקים",
} as const;

/** Breadcrumb labels for structure editor sub-pages. */
export const CUSTOMERS_STRUCTURE_CRUMBS = {
  browse: "הגדרת מבנה דפדוף",
} as const;
